module.exports = __webpack_public_path__ + "img/sales_people.b788bb0e.jpg";